import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ResendIcon from "assets/svgIcons/ResendIcon";
import LoactionIcon from "assets/svgIcons/LocationArrow";
import ListIcon from "assets/svgIcons/ListIcon";
import AdminIcon from "assets/svgIcons/AdminIcon";
import { AccordionWrapper } from "commonComponents/CarDetails/AccordionDetails/AccordionDetailsStyled";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import TimeIcon from "assets/icons/time-icon.png";
import {
    UPDATED_CAR_DATA_STATE,
    SITEID_GLOBAL_STATE
} from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { useTranslation } from "react-i18next";
import { useCarSettingsData } from "_helperFunctions/carSettings";
import _ from "lodash";
import { isCarInUse } from "_helperFunctions/isCarInUse";
import { isStale } from "_helperFunctions/isStale";
import { carType, isUserAdmin, isUserMaster, isUserSupport, controlType, deviceType } from "constant";
import { FaAddressCard } from "react-icons/fa";
import { CarInfoContainer } from "commonComponents/CarDetails/CarDetailsStyled";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import CheckIcon from "assets/svgIcons/CheckIcon";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import ChangeIcon from "assets/svgIcons/ChangeIcon";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { PopUpContainer } from "assets/css/globle";
import { getGuardianState } from "_helperFunctions/guardianState";

export default function DetailAccordions(Props) {
    const dispatch = useDispatch();

    const { centralDeviceInfo } = useHookstate(SITEID_GLOBAL_STATE);

    const { t } = useTranslation();

    const { isSiteUsingYards, convertMileToKM } = useCarSettingsData();

    const { carProductData, siteSettingsData, getUserRole, stagingModeData, getPackageManifestsData } = useSelector((state) => state.commonReducers) || [];

    const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);

    let LOCATION_BETWEEN_HOLES = 1;
    let LOCATION_TEE = 2;
    let LOCATION_FAIRWAY = 3;
    let LOCATION_GREEN = 4;

    let LOCATION_BETWEEN_HOLES_STR = "BetweenHoles";
    let LOCATION_TEE_STR = "Tee";
    let LOCATION_FAIRWAY_STR = "Fairway";
    let LOCATION_GREEN_STR = "Green";
    const confirmPopupStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        maxWidth: "400px",
        width: "calc(100% - 40px)",
        bgcolor: "background.paper",
        borderRadius: "5px",
        overflow: "hidden",
    };

    // Serial number format: 1+ letters, 4 digits, dash, 6 digits
    const serialNumberValidFormat = /^[A-Za-z0-9][A-Za-z]*\d{4}-\d{6}$/;
    const meterFormat = /^(?:[0-9]{1,6}|999999)$/;
    const [serialNumberError, setSerialNumberError] = React.useState("");
    const [hrMeterError, setHrMeterError] = React.useState("");
    const [gpsOdometerError, setGpsOdometerError] = React.useState("");
    const [savingField, setSavingField] = React.useState(null);
    const [expanded, setExpanded] = React.useState(false);
    const [editCarField, setEditCarField] = React.useState(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [okPopUp, setOkPopUp] = useState(false);
    const [guardianConfirm, setGuardianConfirm] = useState(false);
    const [deregisterConfirm, setDeregisterConfirm] = useState(false);
    const guardianState = getGuardianState(Props?.car?.Car);
    const [guardianCapable, setGuardianCapable] = useState(guardianState?.checked);
    const [carInfo, setCarInfo] = React.useState({
        year: Props?.car?.NonCommunicativeVehicle?.CarYear || '',
        make: Props?.car?.NonCommunicativeVehicle?.CarMake || '',
        model: Props?.car?.NonCommunicativeVehicle?.CarModel || '',
        ctrlModel: Props?.car?.NonCommunicativeVehicle?.ControllerModel || '',
        serialNumber: Props?.car?.NonCommunicativeVehicle?.SerialNumber || '',
        GPSOdometer: Props?.car?.Car?.GPSOdometerBase ?? '',
        hrMeter: Props?.car?.Car?.VirtualHourmeterBase ?? ''
    });

    useEffect(() => {
        const payload = { GpsiCarId: Props?.gpsiCarId };

        dispatch(COMMON_SERVICES.getProductData(payload));

        dispatch(COMMON_SERVICES.getPackageManifestsServices());
    }, [Props.gpsiCarId]);

    const handleCarInfoChange = (e) => {
        const { name, value } = e.target;
        setCarInfo((prev) => ({ ...prev, [name]: value }));
    }

    const handleSerialNumberClick = (e) => {
        if (canUpdateSerialNumber()) {
            setEditCarField('serialNumber')
        }
    }

    const handleGpsOdometerClick = (e) => {
        setEditCarField('GPSOdometer')
    }

    const handleHrMeterClick = (e) => {
        setEditCarField('hrMeter')
    }

    const gasCarWithVDU = () => {
        return ([deviceType.VDU3, deviceType.VDU4].includes(Props?.car?.Car?.DevType) &&
            ((Props?.car?.Car?.CarControlType === controlType.Fusion &&
                Props?.car?.Car?.BatteryLevel > 100)
                || Props?.car?.Car?.CarControlType === controlType.GCCM))
    }

    const handleFieldBlur = (e) => {
        const { name, value } = e.target;
        setCarInfo((prev) => {
            const original = Props?.car?.NonCommunicativeVehicle || {};
            let hasChanged = false;
            if (name === 'serialNumber') {
                hasChanged = value !== (original.SerialNumber || '');
                if (hasChanged && Props?.car?.CanCarCommunicate && !isSerialNumberValid()) {
                    setSerialNumberError(t("Invalid_Format"));
                    setEditCarField('serialNumber');
                    return { ...prev, serialNumber: original.SerialNumber || '' };
                } else {
                    setSerialNumberError("");
                }
            } else if (name === 'GPSOdometer') {
                hasChanged = value !== (Props?.car?.Car?.GPSOdometerBase || '');
                if (hasChanged && Props?.car?.Car?.GPSOdometerBase && !isGPSOdometerValid()) {
                    setGpsOdometerError(t("Invalid_Format"));
                    setEditCarField('GPSOdometer');
                    return { ...prev, GPSOdometer: Props?.car?.Car?.GPSOdometerBase || '' };
                } else {
                    setGpsOdometerError("");
                }
            } else if (name === 'hrMeter') {
                hasChanged = value !== (Props?.car?.Car?.VirtualHourmeterBase || '');
                if (hasChanged && Props?.car?.Car?.VirtualHourmeterBase && !isHrMeterValid()) {
                    setHrMeterError(t("Invalid_Format"));
                    setEditCarField('hrMeter');
                    return { ...prev, hrMeter: Props?.car?.Car?.VirtualHourmeterBase || '' };
                } else {
                    setGpsOdometerError("");
                }
            } else if (name === 'year') {
                hasChanged = value !== (original.CarYear || '');
            } else if (name === 'make') {
                hasChanged = value !== (original.CarMake || '');
            } else if (name === 'model') {
                hasChanged = value !== (original.CarModel || '');
            } else if (name === 'ctrlModel') {
                hasChanged = value !== (original.ControllerModel || '');
            }
            const updated = { ...prev, [name]: value };
            if (hasChanged) {
                setSavingField(name);
                const payload = {
                    GpsiCarId: Props?.car?.Car?.GpsiCarId,
                    SerialNumber: name === 'serialNumber' ? value : prev.serialNumber,
                    CarYear: name === 'year' ? value : prev.year,
                    CarMake: name === 'make' ? value : prev.make,
                    CarModel: name === 'model' ? value : prev.model,
                    ControllerModel: name === 'ctrlModel' ? value : prev.ctrlModel,
                };
                if (name === "GPSOdometer") {
                    dispatch(COMMON_SERVICES.saveGPSOdometerBaseServices({ gpsiCarId: Props?.car?.Car?.GpsiCarId, gpsOdometerBase: prev.GPSOdometer }))
                        .finally(() => setSavingField(null));
                }
                else if (name === "hrMeter") {
                    dispatch(COMMON_SERVICES.saveHrMeterBaseServices({ gpsiCarId: Props?.car?.Car?.GpsiCarId, virtHrMeterBase: prev.hrMeter }))
                        .finally(() => setSavingField(null));
                }
                else if (!Props?.car?.CanCarCommunicate || gasCarWithVDU()) {
                    dispatch(COMMON_SERVICES.saveNonCommunicateVehiclesServices(payload))
                        .finally(() => setSavingField(null));
                }
                else if (Props?.car?.CanCarCommunicate && isSerialNumberValid()) {
                    dispatch(COMMON_SERVICES.saveCarSerialBaseServices({ gpsiCarId: Props?.car?.Car?.GpsiCarId, serialNumber: name === 'serialNumber' ? value : prev.serialNumber }))
                        .finally(() => setSavingField(null));
                }
            }
            setEditCarField(null);
            return updated;
        });
    }

    const handleFieldKeyDown = (e) => {
        if (e.key === 'Enter') {
            setEditCarField(null);
        }
    }

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    }

    function renderCarName() {
        if (carProductData && carProductData.CarType === 0) {
            return <span className="card-view"></span>;
        } else if (carProductData && carProductData.CarType === carType.normal) {
            return <span className="card-view">{t("Fleet_car")}</span>;
        } else if (carProductData && carProductData.CarType === carType.marshal) {
            return <span className="card-view">Marshal car</span>;
        } else if (carProductData && carProductData.CarType === carType.handicap) {
            return <span className="card-view">{t("Special_needs_cars")}</span>;
        } else if (carProductData && carProductData.CarType === carType.bevcart) {
            return <span className="card-view">{t("Beverage_cars")}</span>;
        } else if (carProductData && carProductData.CarType === carType.outOfService) {
            return <span className="card-view">{t("Out_of_service")}</span>;
        } else if (carProductData && carProductData.CarType === carType.member && carProductData.SecondaryCarType === carType.handicap) {
            return <span className="card-view">{t("Member_/_Special_Needs")}</span>;
        } else if (carProductData && carProductData.CarType === carType.member) {
            return <span className="card-view">{t("Member_car")}</span>;
        } else if (carProductData && carProductData.CarType === carType.notInUse) {
            return <span className="card-view">Not in use car</span>;
        } else if (carProductData && carProductData.CarType === carType.notCommunicating) {
            return <span className="card-view">Not communicating car</span>;
        } else {
            return <span className="card-view"></span>;
        }
    }

    function canUpdateSerialNumber() {
        if (!Props?.car?.CanCarCommunicate || (Props?.car?.CanCarCommunicate && (carInfo.serialNumber?.length < 12 || !carProductData?.CarSerialNumber) && !serialNumberValidFormat.test(carProductData?.CarSerialNumber))) {
            return true;
        }
        return false;
    }

    function canUpdateMeter() {
        if (!Props?.car?.CanCarCommunicate && (isUserAdmin(getUserRole && getUserRole?.Role) || isUserMaster(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role))) {
            return true;
        }
        return false;
    }

    function isSerialNumberValid() {
        var isValid = false;

        //If it does not have the ability to communicate with motor controller then user can enter anything
        if (!Props?.car?.CanCarCommunicate) {
            isValid = true;
        }
        else if (Props?.car?.CanCarCommunicate && (carInfo.serialNumber?.length === 12 || carInfo.serialNumber?.length === 13) &&
            serialNumberValidFormat.test(carInfo.serialNumber)) {
            isValid = true;
        }
        return isValid;
    }

    function isGPSOdometerValid() {
        var isValid = false;

        //If it does not have the ability to communicate with motor controller then user can enter anything
        if (meterFormat.test(carInfo.GPSOdometer)) {
            isValid = true;
        }
        return isValid;
    }

    function isHrMeterValid() {
        var isValid = false;

        //If it does not have the ability to communicate with motor controller then user can enter anything
        if (meterFormat.test(carInfo.hrMeter)) {
            isValid = true;
        }
        return isValid;
    }

    function holeLocationString(x) {
        if (x === LOCATION_BETWEEN_HOLES || x === LOCATION_BETWEEN_HOLES_STR)
            return "Between Holes";
        else if (x === LOCATION_TEE || x === LOCATION_TEE_STR) return "Tee";
        else if (x === LOCATION_FAIRWAY || x === LOCATION_FAIRWAY_STR)
            return "Fairway";
        else if (x === LOCATION_GREEN || x === LOCATION_GREEN_STR) return "Green";
        else return "Unknown"; // "Unknown Hole Location";
    } // CarLocationInfo unsignedByte / CarDataHistoryInfo UlLocationReportReason

    function locationString() {
        const carsData =
            updatedCarData.get() && updatedCarData.get().length !== 0
                ? JSON.parse(updatedCarData.get())
                : [];

        const index = carsData.findIndex((v) => v?.Car?.CarNumber == Props.carNo);
        const carData = carsData[index];
        var result = "";
        if (
            carData?.Car.Course !== 0 &&
            carData?.Car.Hole !== 0 &&
            siteSettingsData &&
            Object.keys(siteSettingsData).length > 0
        ) {
            result =
                carData?.Car.HoleLocation > 0
                    ? holeLocationString(carData?.Car.HoleLocation)
                    : "";
            var crs = _.find(siteSettingsData?.Courses, {
                Number: carData?.Car.Course,
            });
            result += crs ? " - " + crs.Name : "";
        }
        return result;
    }

    const getCarManifestText = () => {
        if (Props?.car.Car.PackageManifestId) {
            var manifest = getPackageManifestsData?.find((m) => m.ManifestId == Props?.car.Car.PackageManifestId);

            if (!manifest && Props?.car.Car.PackageManifestId) {
                return '[' + (carProductData?.ManifestId ?? Props?.car.Car.PackageManifestId) + '] deleted?';
            }
            else {
                return (manifest) ? '[' + manifest.ManifestId + ']' + ' ' + manifest.ManifestDescription : 'none';
            }
        }

        return 'none';
    }

    const getOdometerDisplay = () => {
        if (!carProductData) return "";

        const odometerBase = carInfo.GPSOdometer !== '' ? Number(carInfo.GPSOdometer) : (Props?.car?.Car?.GPSOdometerBase ?? 0);
        let odometer = 0;
        if (
            carProductData.CarHistoryOdometer !== null &&
            carProductData.CarHistoryOdometer !== undefined &&
            carProductData.CarHistoryOdometer !== 0
        ) {
            odometer = carProductData.CarHistoryOdometer;
        } else if (Props?.car?.Car?.DevType === deviceType.FT2) {
            odometer = carProductData.Odometer ?? 0;
        } else if (!Props?.car?.CanCarCommunicate) {
            odometer = carProductData.GPSOdometer ?? 0;
        } else {
            odometer = carProductData.Odometer ?? carProductData.GPSOdometer ?? 0;
        }

        odometer = odometer ?? 0;

        if (Props?.car?.Car?.CarControlType === controlType.None) {
            odometer = (odometer ?? 0) + odometerBase;
        }

        const isMiles = isSiteUsingYards();
        if (isMiles) {
            const miles = Math.round(odometer ?? 0);
            return `${miles} ${t(miles === 1 ? "mile" : "miles")}`;
        } else {
            const km = Math.round(convertMileToKM(odometer ?? 0));
            return `${km} ${t(km === 1 ? "km" : "kms")}`;
        }
    }

    const getHrMeterDisplay = () => {
        if (!carProductData) return "";
        var hourMeterVal = Props?.car?.Car?.DevType === deviceType.FT2
            ? (carProductData.CarHistoryHourMeter ?? 0)
            : (carProductData.HourMeter ?? 0);
        const hourMeterValue = hourMeterVal ?? 0;
        const hourmeterBase = carInfo.hrMeter !== '' ? Number(carInfo.hrMeter) : (Props?.car?.Car?.VirtualHourmeterBase ?? 0);
        var hrMeter = Math.round(hourMeterValue + hourmeterBase);
        return `${hrMeter} ${t(hrMeter === 1 ? t("hour") : t("hours"))}`;
    }

    const isElectricFleetCar = () => {
        return !!(Props?.car?.CanCarCommunicate &&
            siteSettingsData &&
            Object.keys(siteSettingsData).length > 0 &&
            siteSettingsData?.ElectricFleet);
    }

    return (
        <AccordionWrapper>
            <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChange("panel1")}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Typography>
                        <LoactionIcon />
                        {t("Location")}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <tbody>
                            {Props.ActionZoneId != 0 ? (
                                <div>
                                    {t("Action_Zone")} : {Props.ActionZoneLabel}
                                </div>
                            ) : (
                                ""
                            )}
                            {t("Hole_No")}&nbsp;:&nbsp;
                            {!isStale(Props?.car.Car) && isCarInUse(Props?.car.Car) && (
                                <>
                                    {Props?.holeNo}
                                    {" " + locationString()}
                                </>
                            )}
                            <br />
                            {t("Last_updated")}: {Props?.update()}
                            <p className="date-info">
                                <img src={TimeIcon} alt="time-icon" />

                                {Props?.lastupdate}
                            </p>
                        </tbody>
                    </Typography>
                </AccordionDetails>
            </Accordion>
            {Props?.car?.Car?.CarType === carType.member && <Accordion
                expanded={expanded === "panel4"}
                onChange={handleChange("panel4")}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography>
                        <FaAddressCard fill="#636F7C" size={20} />
                        {t("Member_Details")}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <table className="w-100">
                            <tbody>
                                <tr>
                                    <th colSpan={2} className="align-left">{t("First_Member")}
                                    </th>

                                </tr>
                                <tr>
                                    <td>{t("Name")}</td>
                                    <td className="align-right">
                                        {Props?.car?.Members[0]?.MemberName}
                                    </td>
                                </tr>
                                <tr>
                                    <td>{t("Number")}</td>
                                    <td className="align-right">
                                        {Props?.car?.Members[0]?.MemberNumber}
                                    </td>
                                </tr>
                                <tr>
                                    <td>{t("Email")}</td>
                                    <td className="align-right">
                                        {Props?.car?.Members[0]?.EmailAddress}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {Props?.car?.Members[0]?.MemberName2 && <table className="w-100">
                            <tbody>
                                <tr>
                                    <th colSpan={2} className="align-left">{t("Second_Member")}
                                    </th>

                                </tr>
                                <tr>
                                    <td>{t("Name")}</td>
                                    <td className="align-right">
                                        {Props?.car?.Members[0]?.MemberName2}
                                    </td>
                                </tr>
                                <tr>
                                    <td>{t("Number")}</td>
                                    <td className="align-right">
                                        {Props?.car?.Members[0]?.MemberNumber2}
                                    </td>
                                </tr>
                                <tr>
                                    <td>{t("Email")}</td>
                                    <td className="align-right">
                                        {Props?.car?.Members[0]?.EmailAddress2}
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    </Typography>
                </AccordionDetails>
            </Accordion>}
            <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                >
                    <Typography>
                        <ListIcon />
                        {t("Product_Details")}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <table className="w-100">
                            <colgroup>
                                <col style={{ width: '50%' }} />
                                <col style={{ width: '50%' }} />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <td>{t("Car_serial")} # </td>
                                    <td className="align-right">
                                        <div className="field-row">
                                            {editCarField === 'serialNumber' ? (
                                                <CarInfoContainer style={{ margin: 0, padding: 0 }}>
                                                    <input
                                                        name="serialNumber"
                                                        value={carInfo.serialNumber}
                                                        onChange={handleCarInfoChange}
                                                        onBlur={handleFieldBlur}
                                                        onKeyDown={handleFieldKeyDown}
                                                        maxLength={Props?.car?.CanCarCommunicate ? 13 : 20}
                                                        width={150}
                                                        autoFocus
                                                    />
                                                    {serialNumberError && (
                                                        <div style={{ color: 'red', fontSize: 12, marginTop: 2 }}>{serialNumberError}</div>
                                                    )}
                                                </CarInfoContainer>
                                            ) : (
                                                <>
                                                    <span
                                                        className={(canUpdateSerialNumber() && (isUserAdmin(getUserRole && getUserRole.Role) ||
                                                            isUserSupport(getUserRole && getUserRole.Role) || isUserMaster(getUserRole && getUserRole.Role))) ? "editable-field" : ""}
                                                        title={t('Click_to_edit')}
                                                        onClick={handleSerialNumberClick}
                                                        tabIndex={0}
                                                        onFocus={handleSerialNumberClick}
                                                    >
                                                        {carInfo.serialNumber || (Props?.car?.CanCarCommunicate ? carProductData?.CarSerialNumber : Props?.car?.NonCommunicativeVehicle?.SerialNumber) || <span style={{ color: '#aaa' }}>{t('Click_to_edit')}</span>}

                                                    </span>
                                                    {savingField === 'serialNumber' && <ResendIcon className="rotate" />}
                                                </>
                                            )}
                                        </div>
                                    </td>
                                </tr>

                                {!Props?.car?.CanCarCommunicate || gasCarWithVDU() ? <><tr>
                                    <td>{t("Year")}</td>
                                    <td className="align-right">
                                        <div className="field-row">
                                            {editCarField === 'year' ? (
                                                <CarInfoContainer style={{ margin: 0, padding: 0 }}>
                                                    <input
                                                        name="year"
                                                        value={carInfo.year}
                                                        onChange={handleCarInfoChange}
                                                        onBlur={handleFieldBlur}
                                                        onKeyDown={handleFieldKeyDown}
                                                        maxLength={4}
                                                        autoFocus
                                                    />
                                                </CarInfoContainer>
                                            ) : (
                                                <>
                                                    <span
                                                        className="editable-field"
                                                        title={t('Click_to_edit')}
                                                        onClick={() => setEditCarField('year')}
                                                        tabIndex={0}
                                                        onFocus={() => setEditCarField('year')}
                                                    >
                                                        {carInfo.year || <span style={{ color: '#aaa' }}>{t('Click_to_edit')}</span>}
                                                    </span>
                                                    {savingField === 'year' && <ResendIcon className="rotate" />}

                                                </>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                                    <tr>
                                        <td>{t("Make")}</td>
                                        <td className="align-right">
                                            <div className="field-row">
                                                {editCarField === 'make' ? (
                                                    <CarInfoContainer style={{ margin: 0, padding: 0 }}>
                                                        <input
                                                            name="make"
                                                            value={carInfo.make}
                                                            onChange={handleCarInfoChange}
                                                            onBlur={handleFieldBlur}
                                                            onKeyDown={handleFieldKeyDown}
                                                            maxLength={20}
                                                            autoFocus
                                                        />
                                                    </CarInfoContainer>
                                                ) : (
                                                    <>
                                                        <span
                                                            className="editable-field"
                                                            title={t('Click_to_edit')}
                                                            onClick={() => setEditCarField('make')}
                                                            tabIndex={0}
                                                            onFocus={() => setEditCarField('make')}
                                                        >
                                                            {carInfo.make || <span style={{ color: '#aaa' }}>{t('Click_to_edit')}</span>}
                                                        </span>
                                                        {savingField === 'make' && <ResendIcon className="rotate" />}
                                                    </>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{t("Model")}</td>
                                        <td className="align-right">
                                            <div className="field-row">
                                                {editCarField === 'model' ? (
                                                    <CarInfoContainer style={{ margin: 0, padding: 0 }}>
                                                        <input
                                                            name="model"
                                                            value={carInfo.model}
                                                            onChange={handleCarInfoChange}
                                                            onBlur={handleFieldBlur}
                                                            onKeyDown={handleFieldKeyDown}
                                                            maxLength={20}
                                                            autoFocus
                                                        />
                                                    </CarInfoContainer>
                                                ) : (
                                                    <>
                                                        <span
                                                            className="editable-field"
                                                            title={t('Click_to_edit')}
                                                            onClick={() => setEditCarField('model')}
                                                            tabIndex={0}
                                                            onFocus={() => setEditCarField('model')}
                                                        >
                                                            {carInfo.model || <span style={{ color: '#aaa' }}>{t('Click_to_edit')}</span>}
                                                        </span>
                                                        {savingField === 'model' && <ResendIcon className="rotate" />}
                                                    </>
                                                )}
                                            </div>
                                        </td>
                                    </tr></> : <></>}
                                <tr>
                                    <td>{t("Car_type")}</td>
                                    <td className="align-right">{renderCarName()}</td>
                                </tr>
                                <tr>
                                    <td>{t("Max_speed")}</td>
                                    {stagingModeData && stagingModeData?.GuardianMode === 2 ? (
                                        "0Mph"
                                    ) : (
                                        <td className="align-right">
                                            {carProductData && (carProductData?.MaxSpeed === 0 || carProductData?.MaxSpeed === -1)
                                                ? t("Default")
                                                : isSiteUsingYards()
                                                    ? (carProductData?.MaxSpeed ?? 0) + " mph"
                                                    : Math.round(
                                                        convertMileToKM(carProductData?.MaxSpeed ?? 0)
                                                    ) + " kph"}
                                        </td>
                                    )}
                                </tr>
                                <tr>
                                    <td> {t("MCU_Serial")} #</td>
                                    <td className="align-right">
                                        {carProductData && carProductData?.ControllerModel !== null
                                            ? carProductData?.ControllerModel
                                            : ""}
                                    </td>
                                </tr>
                                <tr>
                                    <td>{t("Odometer")}</td>
                                    <td className="align-right">{getOdometerDisplay()}</td>
                                </tr>
                                {canUpdateMeter() && <tr>
                                    <td>{t("Odometer_Base")}</td>
                                    <td className="align-right">
                                        <div className="field-row">
                                            {editCarField === 'GPSOdometer' ? (
                                                <CarInfoContainer style={{ margin: 0, padding: 0 }}>
                                                    <input
                                                        name="GPSOdometer"
                                                        value={carInfo.GPSOdometer}
                                                        onChange={handleCarInfoChange}
                                                        onBlur={handleFieldBlur}
                                                        onKeyDown={handleFieldKeyDown}
                                                        maxLength={6}
                                                        width={150}
                                                        autoFocus
                                                    />
                                                    {gpsOdometerError && (
                                                        <div style={{ color: 'red', fontSize: 12, marginTop: 2 }}>{gpsOdometerError}</div>
                                                    )}
                                                </CarInfoContainer>
                                            ) : (
                                                <>
                                                    <span
                                                        className={canUpdateMeter() ? "editable-field" : ""}
                                                        title={t('Click_to_edit')}
                                                        onClick={handleGpsOdometerClick}
                                                        tabIndex={0}
                                                        onFocus={handleGpsOdometerClick}
                                                    >
                                                        {carInfo.GPSOdometer ? carInfo.GPSOdometer : Props?.car?.Car?.GPSOdometerBase || <span style={{ color: '#aaa' }}>{t('Click_to_edit')}</span>}
                                                    </span>
                                                    {savingField === 'GPSOdometer' && <ResendIcon className="rotate" />}
                                                </>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                                }
                                <tr>
                                    <td>{t("Hour_Meter")}</td>
                                    <td className="align-right">{getHrMeterDisplay()}</td>
                                </tr>
                                {canUpdateMeter() && <tr>
                                    <td>{t("HourMeter_Base")}</td>
                                    <td className="align-right">
                                        <div className="field-row">
                                            {editCarField === 'hrMeter' ? (
                                                <CarInfoContainer style={{ margin: 0, padding: 0 }}>
                                                    <input
                                                        name="hrMeter"
                                                        value={carInfo.hrMeter}
                                                        onChange={handleCarInfoChange}
                                                        onBlur={handleFieldBlur}
                                                        onKeyDown={handleFieldKeyDown}
                                                        maxLength={6}
                                                        width={150}
                                                        autoFocus
                                                    />
                                                    {hrMeterError && (
                                                        <div style={{ color: 'red', fontSize: 12, marginTop: 2 }}>{hrMeterError}</div>
                                                    )}
                                                </CarInfoContainer>
                                            ) : (
                                                <>
                                                    <span
                                                        className={canUpdateMeter() ? "editable-field" : ""}
                                                        title={t('Click_to_edit')}
                                                        onClick={handleHrMeterClick}
                                                        tabIndex={0}
                                                        onFocus={handleHrMeterClick}
                                                    >
                                                        {carInfo.hrMeter ? carInfo.hrMeter : Props?.car?.Car?.VirtualHourmeterBase || <span style={{ color: '#aaa' }}>{t('Click_to_edit')}</span>}
                                                    </span>
                                                    {savingField === 'hrMeter' && <ResendIcon className="rotate" />}
                                                </>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                                }
                                <tr>
                                    <td>{t("Key_on")}</td>
                                    <td className="align-right">{Props?.car?.Car?.KeyOnHours}
                                        {Props?.car?.Car?.KeyOnHours == null ? "" : Props?.car?.Car?.KeyOnHours > 1 ? t("hours") : t("hour")}</td>
                                </tr>
                                {isElectricFleetCar() && <tr>
                                    <td>{t("Amp_Hours")}</td>
                                    <td className="align-right">
                                        {carProductData ? carProductData?.EnergyUnits : ""}
                                    </td>
                                </tr>}
                                {isElectricFleetCar() && Props?.car?.Car?.CarControlType == controlType.Fusion && <tr>
                                    <td>{t("kW_Hours")}</td>
                                    <td className="align-right">
                                        {carProductData ? ((carProductData?.WattHours ?? 0) / 1000) : ""}
                                    </td>
                                </tr>}
                                <tr>
                                    {/* Value is cleared for now. once its implemented from device side it will be included */}
                                    <td>{t("CC_Connect_Model")}</td>
                                    <td className="align-right">
                                        {centralDeviceInfo.get()?.find(x => x.carId == Props?.car?.Car?.CarNumber)?.partNumber}
                                    </td>
                                </tr>
                                <tr>
                                    {/* Value is cleared for now. once its implemented from device side it will be included */}
                                    <td>{t("CC_connect_serial")} #</td>
                                    <td className="align-right">
                                        {centralDeviceInfo.get()?.find(x => x.carId == Props?.car?.Car?.CarNumber)?.serialNumber}
                                    </td>
                                </tr>
                                <tr>
                                    <td>{t("CC_connect_ID")} {t("(GPSI_Car_ID)")}</td>
                                    <td className="align-right">
                                        {carProductData && carProductData?.GpsiCarId}
                                    </td>
                                </tr>
                                {(isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role)) &&
                                    <>
                                        {carProductData && carProductData?.FusionVersions &&
                                            <tr style={{ backgroundColor: "#c1e1e0", padding: 4 }}>
                                                <td>VCM | MCU | BMS</td>
                                                <td className="align-right">
                                                    {carProductData && carProductData?.FusionVersions}
                                                </td>
                                            </tr>
                                        }
                                        <tr style={{ backgroundColor: "#c1e1e0", padding: 4 }}>
                                            <td>Manifest</td>
                                            <td className="align-right">
                                                {getCarManifestText()}
                                            </td>
                                        </tr>
                                    </>
                                }

                                {carProductData &&
                                    carProductData.length > 0 &&
                                    carProductData.map((item, id) => {
                                        return (
                                            <tr key={item.GpsiCarId}>
                                                <td>{item.GpsiCarId}</td>
                                                <td>{item.CarType}</td>
                                                <td>{item.MaxSpeed}</td>
                                                <td>{item.MaxSpeed}</td>
                                                <td>{item.Odometer}</td>
                                                <td>{item.MaxSpeed}</td>
                                                <td>{item.ControllerModel}</td>
                                                <td>{item.CarSerialNumber}</td>
                                                <td>{item.MaxSpeed}</td>
                                                <td>{item.MaxSpeed}</td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion
                expanded={expanded === "panel3"}
                onChange={handleChange("panel3")}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                >
                    <Typography>
                        <ChangeIcon />
                        {t("Charge_History")}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography></Typography>
                </AccordionDetails>
            </Accordion>
            {((isUserAdmin(Props?.getUserRole)) || (isUserSupport(Props?.getUserRole)) || (isUserMaster(Props?.getUserRole))) && <Accordion
                expanded={expanded === "panel5"}
                onChange={handleChange("panel5")}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel5bh-content"
                    id="panel5bh-header"
                >
                    <Typography>
                        <AdminIcon style={{ marginRight: 6, verticalAlign: 'middle' }} />
                        {t("Product_Settings")}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <div className="checkbox-wrapper">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={[deviceType.VDU3, deviceType.VDU4].includes(Props?.car?.Car?.DevType) ? false : !!Props.useVoltage}
                                        disabled={[deviceType.VDU3, deviceType.VDU4].includes(Props?.car?.Car?.DevType)}
                                        onClick={() => {
                                            const newValue = !Props.useVoltage;
                                            if (Props.setUseVoltage) Props.setUseVoltage(newValue);
                                            Props.handleAdminSettingsChange('UseVoltage', newValue);
                                        }}
                                        inputProps={{ "aria-label": "controlled" }}
                                        icon={<UnCheckIcon width={20} height={20} />}
                                        checkedIcon={<CheckIcon width={20} height={20} />}
                                    />
                                }
                                label={t("Use_Battery_Voltage")}
                            />
                        </div>
                        <div className="checkbox-wrapper">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={guardianCapable}
                                        onClick={() => {
                                            setShowConfirm(true);
                                            setGuardianConfirm(true);
                                        }}
                                        disabled={guardianState?.disabled}
                                        inputProps={{ "aria-label": "controlled" }}
                                        icon={<UnCheckIcon width={20} height={20} />}
                                        checkedIcon={<CheckIcon width={20} height={20} />}
                                    />
                                }
                                label={t("Guardian_capable")}
                            />
                        </div>
                        <div className="checkbox-wrapper">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={false}
                                        onClick={() => {
                                            setShowConfirm(true);
                                            setDeregisterConfirm(true);
                                        }}
                                        inputProps={{ "aria-label": "controlled" }}
                                        icon={<UnCheckIcon width={20} height={20} />}
                                        checkedIcon={<CheckIcon width={20} height={20} />}
                                    />
                                }
                                label={t("Deregister_car")}
                            />
                        </div>
                    </Typography>
                </AccordionDetails>
            </Accordion>}
            <Modal
                open={showConfirm}
                onClose={() => setShowConfirm(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={confirmPopupStyle}>
                    <PopUpContainer>
                        <h2>{t("Confirm")}</h2>
                        <p>{(deregisterConfirm && t("Deregister_Confirm_Msg")) ||
                            (guardianConfirm && (!guardianCapable ? t("Guardian_Enable_Msg") :
                                t("Guardian_Disable_Msg")))
                        }</p>
                        <div className="action-btn">
                            <button
                                onClick={() => {
                                    deregisterConfirm && Props.handleAdminSettingsChange('Deregister', true);
                                    if (guardianConfirm) { setGuardianCapable(!guardianCapable); Props.handleAdminSettingsChange('GuardianCapable', !guardianCapable); setOkPopUp(true); };
                                    setShowConfirm(false);
                                    setGuardianConfirm(false);
                                    setDeregisterConfirm(false);
                                }}
                                className="primary"
                            >
                                {t("Yes")}
                            </button>
                            <button onClick={() => { setShowConfirm(false); setGuardianConfirm(false); setDeregisterConfirm(false); }}>
                                {t("No")}
                            </button>
                        </div>
                    </PopUpContainer>
                </Box>
            </Modal>
            <Modal
                open={okPopUp}
                onClose={() => setOkPopUp(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={confirmPopupStyle}>
                    <PopUpContainer className="py-30">
                        <h2></h2>
                        <p>
                            {t("Guardian_Change_Info")}
                        </p>
                        <div className="action-btn">
                            <button className="primary" onClick={() => setOkPopUp(false)}>
                                {t("Ok")}
                            </button>
                        </div>
                    </PopUpContainer>
                </Box>
            </Modal>
        </AccordionWrapper >
    );
}
